import { render, staticRenderFns } from "./ComplaintAgilizaState.vue?vue&type=template&id=51ed9dd4"
import script from "./ComplaintAgilizaState.vue?vue&type=script&lang=js"
export * from "./ComplaintAgilizaState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports